import React from 'react'
import SelectableCard from "../../../../../../../components-new/general/SelectableCard";
import Translate from "../../../../../../../components/Translate";
import PowerIcon from "../../../../../../../assets/icons/PowerIcon";
import colors from "../../../../../../../utils/Colors";
import PhoneCallIcon from "../../../../../../../assets/icons/PhoneCallIcon";
import HouseIcon from "../../../../../../../assets/icons/HouseIcon";
import ForumIcon from "../../../../../../../assets/icons/ForumIcon";

const cardStyle = {width: '100px', height: '100px'};

const innerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: '100%',
    height: '100%',
    gap: '10px'
};

const labelStyle = {fontSize: '12px', textAlign: 'center', height: '45px'};

const Actions = ({
                     terminalMessage,
                     callToOperator,
                     chatWithOperator,
                     toStart,
                     setCallToOperator,
                     setChatWithOperator,
                     setTerminalMessage,
                     setToStart
}) => {
    return (
        <div className="control-section" style={{ padding: "8px" }} >

            <div style={{ display: "flex", gap: '6px', flexWrap: 'wrap', justifyContent: 'center', margin: '10px 0' }}>
                <SelectableCard
                    isSelected={terminalMessage}
                    onSelect={() => setTerminalMessage(prev => !prev)}
                    style={cardStyle}
                    className='node-editor-actions-end-chat'
                >
                    <div style={innerStyle}>
                        <PowerIcon style={{color: terminalMessage ? colors.red : colors.silver}} stroke="currentColor" />
                        <span style={{...labelStyle, color: terminalMessage ? colors.red : colors.silver}}><Translate text="endConversation"/></span>
                    </div>
                </SelectableCard>
                <SelectableCard
                    isSelected={toStart}
                    onSelect={() => setToStart(prev => !prev)}
                    style={cardStyle}
                    className='node-editor-actions-to-start'
                >
                    <div style={innerStyle}>
                        <HouseIcon style={{color: toStart ? colors.green : colors.silver}} stroke="currentColor" />
                        <span style={{...labelStyle, color: toStart ? colors.green : colors.silver}}><Translate text="toStart"/></span>
                    </div>
                </SelectableCard>
                <SelectableCard
                    isSelected={chatWithOperator}
                    onSelect={() => setChatWithOperator(prev => !prev)}
                    style={cardStyle}
                >
                    <div style={innerStyle}>
                        <ForumIcon style={{color: chatWithOperator ? colors.blue : colors.silver}} />
                        <span style={{...labelStyle, color: chatWithOperator ? colors.blueDark : colors.silver}}><Translate text="chatWithOperator"/></span>
                    </div>
                </SelectableCard>
                <SelectableCard
                    isSelected={callToOperator}
                    onSelect={() => setCallToOperator(prev => !prev)}
                    style={cardStyle}
                    className='node-editor-actions-call-to-operator'
                >
                    <div style={innerStyle}>
                        <PhoneCallIcon style={{color: callToOperator ? colors.yellow : colors.silver}} stroke="currentColor" />
                        <span style={{...labelStyle, color: callToOperator ? colors.yellow : colors.silver}}><Translate text="callToOperator"/></span>
                    </div>
                </SelectableCard>

            </div>

        </div>
    )
}

export default Actions;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/partials/Actions.jsx